var { store, Modal, inject } = __app__;

class FormAjax
{
	constructor(containerId, form, params = {})
	{
		this.containerId = containerId;
		this.form = form;
		this.fields = [...this.form.elements];
		this.validatedFields = this.fields.filter(({ type }) => ['checkbox', 'radio', 'file'].indexOf(type) === -1);
		this.fileFields = this.fields.filter(({ type }) => type === 'file');
		this.params = params;

		this.allowSave = false;

		this.initUserAgreement();
		this.initMask();
		this.initRating();

		this.bindEvents();
	}

	bindEvents()
	{
		this.form.addEventListener('submit', this.onSubmitHandle.bind(this));
		this.fileFields.forEach(field => {
			field.addEventListener('change', this.updateFileName.bind(this));
		});
	}

	onSubmitHandle(event)
	{
		event.preventDefault();
		event.stopPropagation();

		if (!this.validate())
			return false;

		this.submitEnabled = true;

		if (this.userAgreementControl)
		{
			BX.onCustomEvent(this.userAgreementControl.config.submitEventName, []);
		}
		else
		{
			this.send();
		}
	}

	onDisposeHandle(event)
	{
		if (store.state.ui.modal.activeId)
		{
			const modal = Modal.getInstanceById(store.state.ui.modal.activeId);
			if (modal)
				modal.enable();
		}
	}

	prepareFormData()
	{
		const data = new FormData(this.form);

		this.fields
			.filter(el => el.tagName === 'INPUT' && el.type === 'submit')
			.forEach(({ name, value }) => {
				data.append(name, value);
			});

		return data;
	}

	startLoader()
	{
		const modal = Modal.getInstanceById(store.state.ui.modal.activeId);
		if (modal)
		{
			modal.disable();
			modal.element.focus();
		}
		else
		{
			this.loader = new Modal;
			this.loader
				.addBackdrop()
				.startLoader();
		}
	}

	endLoader()
	{
		const modal = Modal.getInstanceById(store.state.ui.modal.activeId);
		if (modal)
		{
			modal.enable();
		}
		else if (this.loader)
		{
			this.loader.dispose();
			this.loader = null;
		}
	}

	async send()
	{
		if (this.submitEnabled !== true)
			return;

		this.startLoader();

		try
		{
			const url = this.form.action || '';
			const method = this.form.method || 'POST';
			const dataType = 'json';
			const preparePost = false;
			const data = this.prepareFormData();

			const result = await new Promise((resolve, reject) => {
				const onsuccess = resolve;
				const onfailure = reject;
				BX.ajax({ url, method, dataType, data, onsuccess, onfailure, preparePost });
			});

			if (result.status !== 'success')
				throw new Error(result.errors);

			const container = document.getElementById(this.containerId);
			if (container)
			{
				const { html, assets } = result.data;

				await inject.assets(assets);

				const newContainer = document.createElement('div');
				newContainer.innerHTML = html;
				container.parentNode.replaceChild(newContainer.children[0], container);
				await inject.content(html);
			}
			else
			{
				throw new Error('Container not found');
			}
		}
		catch(e)
		{
			console.error(e);
		}
		finally
		{
			this.endLoader();
		}

		return true;
	}

	validate()
	{
		this.validatedFields
			.filter(element => element.classList.contains('is-invalid'))
			.forEach(element => {
				element.classList.remove('is-invalid');
			})

		const notValidFields = this.validatedFields
			.filter(element => !element.checkValidity());

		notValidFields
			.forEach(element => {
				let invalid = element.parentNode.querySelector('.invalid-feedback');
				if (!invalid)
				{
					invalid = document.createElement('div');
					invalid.classList.add('invalid-feedback');
					element.parentNode.appendChild(invalid);
				}

				invalid.innerHTML = element.validationMessage;
				element.classList.add('is-invalid');
			})


		return this.form.checkValidity();
	}

	updateFileName({ target })
	{
		if (!target.files)
			return;

		const label = document.querySelector(`[for="${target.id}"]`);
		if (label)
			label.innerHTML = target.files[0].name;
	}

	initUserAgreement()
	{
		this.userAgreementControl = BX.UserConsent && BX.UserConsent.load(this.form);
		if (this.userAgreementControl)
		{
			BX.addCustomEvent(this.userAgreementControl, BX.UserConsent.events.save, () => {
				this.send();
			});

			BX.addCustomEvent(this.userAgreementControl, BX.UserConsent.events.refused, () => {
				this.submitEnabled = false;
			});
		}
	}

	initMask()
	{
		if ('IMask' in window)
		{
			this.params.mask.forEach(({ fields, mask }) => {
				this.fields
					.filter(el => fields.indexOf(el.dataset.fieldSid) >= 0)
					.forEach(el => {
						IMask(el, { mask });
					});
			});
		}
	}

	initRating()
	{
		const rates = this.fields
			.filter(el => el.dataset.fieldSid === 'RATING')
			.map(({ parentNode }) => parentNode);

		const clearRate = (className = 'is-voted') => rates.forEach(el => el.classList.remove(className));
		const applyRate = (index, className) => rates.slice(0, index + 1).forEach(el => el.classList.add(className))

		rates.forEach((el, index) => {
			el.addEventListener('mouseenter', () => applyRate(index, 'is-hover'));
			el.addEventListener('mouseleave', () => rates.forEach(el => el.classList.remove('is-hover')));
			el.addEventListener('click', () => clearRate() & applyRate(index, 'is-voted'));
		});
	}
}

__app__.Components = __app__.Components || {};
__app__.Components.FormAjax = FormAjax;